<template>

<section class="footer"  :class="{footerdiv: footertheme === 'footerdiv'}" style="">
  <!-- ======= Footer ======= --> 
 
    <div class="container footercontainer">
        <div class="row">
          <div class="col-lg-3 col-md-6 footer-contact">
            <img class=" footerimage" src="@/assets/relibridgemineralslogo.png" style="background-color: transparent;" />
            <p>
              {{ nbaddress }} <br>
              {{ nbaddress2 }}<br>
              {{ nbaddress3}} <br><br>
              <strong>Phone:</strong> {{ nbphone}}<br>
              <strong>Email:</strong> {{ nbemail}}<br>
            </p>
          </div>

          <div class="col-lg-2 col-md-6 footer-links">
            <h4>{{ $t('Useful Links')}}</h4>
            <ul>
              <li v-for="alink in usefullinks">
                <i class="bx bx-chevron-right"></i> 
                <router-link class="indenttextlinksft" :to="{path: alink.usefullinkhref}" @click="setnewLink($event=alink.ullevel1ref)">
                  {{ alink.usefullinkname }} 
                </router-link>
              </li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-6 footer-links">
            <h4>{{ $t('Other portfolios')}}</h4>
            <ul>
              <li v-for="aservice in ourservices">
                <i class="bx bx-chevron-right"></i> 
                <router-link class="indenttextlinksft" :to="{path: aservice.servicelinkhref}" @click="setnewLink($event=aservice.oplevel1ref)">
                  {{ aservice.servicename }}
                </router-link>
              </li>
              <li class="tmuse" data-bs-toggle="modal" data-bs-target="#termsofuse">Terms of use</li>
              <li class="tmuse" data-bs-toggle="modal" data-bs-target="#privacy">Privacy</li>
            </ul>
          </div>

          <div class="col-lg-4 col-md-6 footer-newsletter">
            <h4>{{ $t('Join Our Newsletter')}}</h4>
            <p>{{ nbsubscriptiontext }}</p>
            <form @submit.prevent>
              <input type="email" name="email" v-model="subscriberemail"><input type="submit"  :value="$t('Subscribe')" @click.prevent="registerSubscriber()">
            </form>
          </div>
        </div>
    </div>
    <div class="container-fluid lastfooter">
      <div class="container d-md-flex py-4 ">
        <div class="me-md-auto text-center text-md-start">
          <div class="copyright">
            &copy; Copyright <strong><span>Nexgbits</span></strong>. All Rights Reserved
          </div>
          
        </div>
        <div class="social-links text-center shadow mb-5">
          <a href="#" class="twitter"></a>
          <a href="#" class="facebook faiconscss"><i class="fa-brands fa-square-facebook"></i></a>
          <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
          <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
          <a href="#" class="linkedin faiconscss"><i class="fa-brands fa-linkedin"></i></a>
        </div>
      </div>
    </div>
    <a href="#" class="back-to-top d-flex align-items-center justify-content-center"></a>
</section>

<!-- Modal -->
<div class="modal fade" id="termsofuse" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">Terms of Use</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div v-html="termsofservices"></div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="privacy" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">Privacy</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div v-html="nbprivacy"></div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


<div class="modalclass" id="showHide">
  <input type="hidden" @click="openModal = true" />
  <div v-if="openModal">
    <!-- <div class="modal-background"></div> -->
    <div class="modal-content">
      <div class="card">
        <div class="card-header" style="background-color: red; color: white; font-weight: bold">
          Privacy
        </div>
        <div class="card"  style="background-color: #003; color: white;">
          <div class="card-body" >
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-10">
                <div v-html="popmessage"></div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2">
                <button class="card-link btn btn-primary" @click="showHideModel()">Yes</button>
                <button class="card-link btn btn-success" @click="hideModal()">No</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { useToast } from "vue-toastification";


export default {
    name: 'FooterPage',
    props: ['footertheme'],
    data() {
        return {
            subscriberemail: '',
            subscribedemail: '',
            ourservices: [],
            usefullinks: [],
            nbaddress: '',
            nbaddress2: '',
            nbaddress3: '',
            nbphone: '',
            nbemail: '',
            nbjoinletter: '',
            nbsubscriptiontext: '',
            openModal: true,
            termsofservices: '',
            nbprivacy: '',
            popmessage: '',
        }
    },
  
  methods: {
    dateTime(value) {
      return moment(value).format('YYYY-MMMM-DD');
      },
    
    showHideModel() {
      let elx = document.getElementById('showHide');
      elx.style.visibility = "hidden";
      this.openModal = false
      localStorage.setItem('openModel', false)
    },
    hideModal(){
      let elx = document.getElementById('showHide');
      elx.style.visibility = "hidden";
      this.openModal = false
      localStorage.setItem('openModel', false)
    },
    async registerSubscriber() {
    if (this.subscriberemail === "") {
      if(this.subscriberemail === '') {
              let e = "Email is required."
              const toast = useToast();
              toast.error(e, {
              timeout: 6000
                });
              return;
    }
      }
   
    await axios.get(`getsubscriberemail/${this.subscriberemail}`).then(
        response => {
          let vm = this
          vm.subscribedemail = response.data.subscriberemail
          if(this.subscriberemail === vm.subscribedemail) {
                let e1 = 'Email exists'
                const toast1 = useToast();
                toast1.error(e1, {
                timeout: 6000
                });

            return;
          }
      else {
        const datetime = new Date()
        axios.post('subscribers/', {
        subscriberemail: vm.subscriberemail,
        subscriberdate: moment(datetime),
        unsubscribedate: moment('1900-01-01')
        }).then(response => {
          if (response.status === 201) {
    
              let e = "Record posted successfully."
              const toast = useToast();
              toast.success(e, {
              timeout: 6000
              });
            }
            })
            .catch(e => {
            const toast = useToast();
            toast.error(e, {
            timeout: 6000,
          })
        })
      }

      }).catch((response) => {
            console.log(response)
            })
    
    },
  setnewLink($event) {
    let ulevt = $event
    
      var ael = document.getElementById(ulevt);
      localStorage.setItem('al1active', ulevt)
      let x = document.getElementsByClassName("menulevel1");
      if(x.length > 0) 
        { 
          x[0].classList.remove("menulevel1"); 
        }
        ael.classList.add("menulevel1")
        localStorage.setItem('al1active', ulevt)
   
    // localStorage.setItem('al1active', ulevt)
  }
  },

  async mounted() {
   let opm = localStorage.getItem("openModel")
   if(opm) {
    let localstel = document.getElementById('showHide');
    localstel.style.visibility = "hidden";
    this.openModal = false
   }

    axios.get('nbaddressdetails/1').then(
            response => {
                this.nbaddress = response.data.nbaddress;
                this.nbaddress2 = response.data.nbaddress2;
                this.nbaddress3 = response.data.nbaddress3;
                this.nbphone = response.data.nbphone;
                this.nbemail = response.data.nbemail;
                this.nbjoinletter = response.data.nbjoinletter;
                this.nbsubscriptiontext = response.data.nbsubscriptiontext;
            })
            .catch((error) => {
            console.log(error)
            })
  
    await axios.get('usefullinkscreateview/').then(
    response => {
        this.usefullinks = response.data;
    })
    .catch((error) => {
    console.log(error)
    })

    await axios.get('ourservicescreateview/').then(
    response => {
        this.ourservices = response.data;
    })
    .catch((error) => {
    console.log(error)
    })

    await axios.get('termsofservice/').then(
    response => {
        this.termsofservices = response.data[0].nbtermofservice
        this.nbprivacy = response.data[0].nbprivacy
        this.popmessage = response.data[0].popmessage
    })
    .catch((error) => {
    console.log(error)
    })
     
  }
  }
</script>
<style scoped lang="scss">
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap');
body {
  background-color: WHITE;
  width:100%;
  height:100vw;
  padding:0;
  margin:0;
}

.footer{
  color: white;
  font-size: 17px;
  background-image: url("../assets/slide-5.jpg");
  opacity: 0.99;
  bottom: 0;
  padding-bottom: 0;
  position: relative;
  padding-top: 100px;
  line-height: 34px;
}

.indenttextlinksft {
  color: white;
}

ul {
  list-style: none;
}

.faiconscss{
  font-size: 30px;
  padding-left: 5px;
  transition: all 0.2s ease-in-out;
  border: solid thin #003;
  border-radius: 5px;
}
ul li {
  padding-top: 10px;
}

.lastfooter {
  background-color: #003;
}
.imglogo {
  margin-left: -14px;
}
.indenttextlinksft {
  text-decoration: none;
}
.tmuse {
  cursor: pointer;
}
.modal-header, .modal-footer {
  background-color: #003;
  color: white;
}
.btn-close {
  background-color: white;
}
.modalbottom { 
  position: absolute;
  bottom: 10vh
}
.modalclass {
  position:fixed;
  bottom:0;
  width:100%;
  height:230px;
  background-color: #003;
}

.footerimage {
  width: 150px; height: 10vh; 
  padding-bottom: 20px;
  margin-left: px;
}
@media only screen and (max-width: 550px) {
  ul {
    margin-left: 10px;
  }
  .footersection{
    left: 0;
    bottom: 0;
    padding-left: 40px;
  
    color: white;
    font-size: 16px;
    background-image: url("../assets/slide-5.jpg");
    opacity: 0.99;
    bottom: 0; 
    min-height: 100vh;
    margin-top: auto;
  }
}
@media only screen and (max-width: 600px) {
  ul {
    margin-left: 10px;
  }
  .modalclass {
    height:380px;
  }
}
@media only screen and (min-width: 600px) {
  .modalclass {
    height:310px;
  }
  }
@media only screen and (min-width: 768px) {
  .modalclass {
    height:250px;
  }
  }
@media only screen and (max-width: 992px) {
.footer {
  min-height: 100vh;
}
.modalclass {
  height:180px;
}
}
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .modalclass {
    height:220px;
  }
  .footerimage {
    width: 180px; height: 11vh; 
    padding-bottom: 20px;
    margin-left: 0px;
  }
}
</style>